// @flow
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSaveContext } from 'components/ResourceFill/providers/ResourceSaveProvider'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import SaveForLaterModal from 'components/ResourceFill/SaveForLaterModal'
import * as React from 'react'

type Props = {
  saveEditLaterModalOpen: boolean,
  setIsSaveAndEditLaterSuccess: (boolean) => void,
  setSaveEditLaterModalOpen: (boolean) => void,
}

function ResourceFillSaveForLaterModal({
  saveEditLaterModalOpen,
  setIsSaveAndEditLaterSuccess,
  setSaveEditLaterModalOpen,
}: Props): React.Node {
  const { isPacket, mode } = React.useContext(ResourceSharedContext) || {}

  const { response } = React.useContext(ResourceResponseContext) || {}

  const { sessions, sessionId } =
    React.useContext(ResourceSessionsContext) || {}

  const { save } = React.useContext(ResourceSaveContext) || {}

  const currentSession = sessions && sessionId ? sessions[sessionId] : null

  const isPublic = React.useMemo(() => {
    if (mode === 'internal') return false

    if (isPacket) {
      return currentSession?.packetResponse?.message?.status === ''
    }
    return response?.message?.status === ''
  }, [
    currentSession?.packetResponse?.message?.status,
    isPacket,
    mode,
    response?.message?.status,
  ])

  if (!saveEditLaterModalOpen) return null
  if (!save) return null

  return (
    <SaveForLaterModal
      afterSubmit={() => setIsSaveAndEditLaterSuccess(true)}
      isPublic={isPublic}
      onHide={() => setSaveEditLaterModalOpen(false)}
      onSave={save}
      session={currentSession}
    />
  )
}

export default ResourceFillSaveForLaterModal
